const configuration = {
  baseUrl: process.env.BASE_URL,
  publicPath: process.env.PUBLIC_PATH,
  nodeEnv: process.env.REGION_ENV,
  useDevTools: process.env.USE_DEV_TOOLS,
  isDeployed: process.env.IS_DEPLOYED,
  rightNow: process.env.RIGHT_NOW_BASE_URL,
  jwtUsername: process.env.JWT_USERNAME,
  jwtPassword: process.env.JWT_PASSWORD,
  googleTagManagerId: process.env.GTM_ID
}

Object.freeze(configuration)

export const getConfiguration = (property = '') => {
  return configuration[property]
}
